import { Grid } from '@mui/material';
import { DetailsRow } from 'lib/ClientDataDetails/Fields';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientDetailsTariffClass } from 'types/ClientDetailsModel';
import TemplateDetails from '../TemplateDetails';

interface TariffClassDetailsProps {
  tariffClass?: ClientDetailsTariffClass;
}

const TariffClassDetails: FunctionComponent<TariffClassDetailsProps> = ({ tariffClass }) => {
  const { t } = useTranslation();
  const translationRoot = 'clients.clientData.tariffClass';

  if (!tariffClass) {
    return null;
  }

  return (
    <Grid container data-testid="tariffClass-container">
      <Grid xs={12} md={6} item px={3} py={2}>
        <TemplateDetails title={t(`${translationRoot}.title`)}>
          <DetailsRow
            type="percentage"
            label={t(`${translationRoot}.loanToValue`)}
            value={tariffClass.loanValue}
          />
        </TemplateDetails>
        {tariffClass?.loanParts?.map((loanPart) => (
          <TemplateDetails title={`Leningdeel ${loanPart.number}`}>
            <DetailsRow
              type="percentage"
              label={t(`${translationRoot}.upperBound`)}
              value={loanPart.upperBound}
            />
            <DetailsRow
              type="percentage"
              label={t(`${translationRoot}.lowerBound`)}
              value={loanPart.lowerBound}
            />
          </TemplateDetails>
        ))}
      </Grid>
    </Grid>
  );
};

export default TariffClassDetails;
